import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { LocaleProvider } from "@douyinfe/semi-ui";
import en_GB from "@douyinfe/semi-ui/lib/es/locale/source/en_GB";
import zh_CN from "@douyinfe/semi-ui/lib/es/locale/source/zh_CN";
import "molstar/lib/mol-plugin-ui/skin/biogeom-lite.scss";
import "./index.css";
import "@scss/global.scss";
import reportWebVitals from "./reportWebVitals";
import router from "./routes";
import { store } from "./state/store";
import { Provider } from "react-redux";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import "./i18n";

const LocaleWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { i18n } = useTranslation();

  // Map i18n language to Semi UI locale
  const locale = useMemo(() => {
    switch (i18n.language) {
      case "zh":
      case "zh-CN":
      case "zh_CN":
        return zh_CN;
      case "en":
      case "en-GB":
      case "en_GB":
      default:
        return en_GB;
    }
  }, [i18n.language]);

  return <LocaleProvider locale={locale}>{children}</LocaleProvider>;
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <LocaleWrapper>
      <RouterProvider router={router} />
    </LocaleWrapper>
  </Provider>,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
